import './Theme.Pagination.Rounded.scss';
export default 'ThemePaginationRounded';
